module.exports = __webpack_public_path__ + "static/img/cont38 (1).a6863e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont38 (1).png
// module id = TAQx
// module chunks = 0